import { useState } from 'react';
import { Theme, useTheme } from '@chakra-ui/react';
import {
  getAvatarColorsArray,
  getRandomColor,
} from 'app/components/Core/ChakraAvatar/utils';
import { CollaboratorChip } from '../types';
import { SuggestedCollaborator } from '../SuggestedCollaboratorsList';
import {
  compareChipWithCollaborator,
  getChip,
} from '../SuggestedCollaboratorsList/utils';

interface UseChipsProps {
  collaborators: CollaboratorChip[];
}

export const useChips = ({ collaborators }: UseChipsProps) => {
  const theme = useTheme<Theme>();

  const [chips, setChips] = useState<CollaboratorChip[]>(collaborators);

  const addChip = (chip: CollaboratorChip) => {
    const randomColor = getRandomColor(
      getAvatarColorsArray(theme),
      chip.initials
    );

    return setChips((chips) => [
      ...chips,
      {
        avatarColors: {
          background: randomColor[200],
          text: randomColor[500],
        },
        ...chip,
      },
    ]);
  };

  const removeChip = (index: number) => {
    const chip = chips[index];
    setChips((chips) => [...chips.slice(0, index), ...chips.slice(index + 1)]);
    return chip;
  };

  const removeAllChips = () => {
    setChips([]);
  };

  const toggleCollaborator = (collaborator: SuggestedCollaborator) => {
    if (collaborator.selected) {
      const chip = getChip(collaborator);
      if (chip) {
        addChip(chip);
      }
    } else {
      const index = chips.findIndex((chip) =>
        compareChipWithCollaborator(chip, collaborator)
      );
      removeChip(index);
    }
  };

  return { chips, addChip, toggleCollaborator, removeChip, removeAllChips };
};
